module.exports = __webpack_public_path__ + "static/img/column_img_12-1.173b2ce3.png";